export default [{
  path: '/pedagogic/appointment-new/:id',
  name: 'pedagogic-appointment-new-save',
  component: () => import('@/views/apps/pedagogic/appointment-new/index.vue'),
}]